const toNumberOrZero = (value) => {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : 0
}

export const hasRemainingFeatureQuota = (quotaData) => {
  if (!quotaData) return false

  const quota = toNumberOrZero(quotaData.quota)
  const credits = toNumberOrZero(quotaData.credits)
  const usage = toNumberOrZero(quotaData.usage)

  return (usage - credits) < quota
}
